module.exports = __webpack_public_path__ + "static/media/ecom.b93efae1.jpg";